import { TemplateApiUrls } from "@/modules/template/common/enum";
import type {
  ICreateLoanRepaymentTemplateRequest,
  ILoanRepaymentTemplate,
  IUpdateLoanRepaymentTemplateRequest,
} from "@/modules/template/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const loanRepaymentTemplateApi = createApi({
  reducerPath: "loanRepaymentTemplateApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getLoanRepaymentTemplate: builder.query<ILoanRepaymentTemplate, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TemplateApiUrls.LoanRepaymentTemplateV2}/${id}`,
      }),
      keepUnusedDataFor: 0,
    }),
    createLoanRepaymentTemplate: builder.mutation<string, ICreateLoanRepaymentTemplateRequest>(
      withIdempotency<ICreateLoanRepaymentTemplateRequest>(
        TemplateApiUrls.LoanRepaymentTemplateV2
      )),
    updateLoanRepaymentTemplate: builder.mutation<string, IUpdateLoanRepaymentTemplateRequest>({
      query: ({ data, id }) => ({
        url: `${TemplateApiUrls.LoanRepaymentTemplateV2}/${id}`,
        method: "PUT",
        data,
      }),
    }),
  }),
});

export const {
  useGetLoanRepaymentTemplateQuery,
  useCreateLoanRepaymentTemplateMutation,
  useUpdateLoanRepaymentTemplateMutation,
} = loanRepaymentTemplateApi;
